import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'custom-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit {


  @Input() class:string = 'h2-responsive';
  @Input() type:string = 'main';

  @Input() title:string = '';
  @Input() subtitle:string = '';

  @HostBinding('className') className = '';
  @HostBinding('attr.id') @Input() id:string = '';
  
  constructor() { }
  
  ngOnInit(): void {
    this.className = 'title-'+this.type+' '+this.class;
  }

}
